import "@/styles.css";
import "@/pricing.css";
import "@/logo.css";
import "@/gallery.css";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "@/components/Layout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminLogin from "@/pages/AdminLogin";
import CityPage from "@/pages/CityPage";
import HomePage from "@/pages/HomePage";
import LegalPage from "@/pages/LegalPage";
import QuotePage from "@/pages/QuotePage";
import ServicePage from "@/pages/ServicePage";

export default function App() { return <Routes><Route path="/" element={<Navigate to="/de" replace />} /><Route path="/:lang" element={<Layout />}><Route index element={<HomePage />} /><Route path="leistungen/:slug" element={<ServicePage />} /><Route path="services/:slug" element={<ServicePage />} /><Route path="orte/:slug" element={<CityPage />} /><Route path="areas/:slug" element={<CityPage />} /><Route path="angebot" element={<QuotePage />} /><Route path="quote" element={<QuotePage />} /><Route path=":type" element={<LegalPage />} /></Route><Route path="/admin/login" element={<AdminLogin />} /><Route path="/admin" element={<AdminDashboard />} /><Route path="*" element={<Navigate to="/de" replace />} /></Routes>; }